// src/app/core/loading.service.ts
import { Injectable, computed, signal } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _count = signal(0);
  loading = computed(() => this._count() > 0);

  start() { this._count.update(n => n + 1); }
  stop()  { this._count.update(n => Math.max(0, n - 1)); }

  // 👇 Simple y tipado
  asObservable(): Observable<boolean> {
    return toObservable(this.loading);
  }

  runWithLoading<T>(source$: Observable<T>): Observable<T> {
    this.start();
    return source$.pipe(finalize(() => this.stop()));
  }
}